// extracted by mini-css-extract-plugin
module.exports = {"heading":"KUQbb","filters":"_6hyd6","pagination":"hvfEo"};